import { useParams } from 'react-router-dom'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { InputTableURLsTable } from '../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import VatRepercutedFinishedStep from './Steps/VatRepercutedFinishedStep'
import useVatLayoutScreenLogic from '../../../../../../specificComponents/inputTableLayouts/vat/VatLayout/useVatLayoutScreenLogic'

interface SingleVatRepercutedProps extends TableComponentProps {}

const SingleVatRepercuted: React.FC<SingleVatRepercutedProps> = ({ userPermissions }) => {
    const params = useParams<{ id: string }>()
    const VatRepercutedId = params.id

    const inputTableURLs: InputTableURLsTable = {
        createData: ['/api/app/accounting/vatRepercuted/vatRepercutedLine/createVatRepercutedLine', { VatRepercutedId }],
        getData: ['/api/app/accounting/vatRepercuted/getVatRepercutedComplete', { id: VatRepercutedId }],
        updateData: '/api/app/accounting/vatRepercuted/vatRepercutedLine/updateVatRepercutedLine',
        delete: '/api/app/accounting/vatRepercuted/vatRepercutedLine/deletevatRepercutedLine',
        updateHeaderData: '/api/app/accounting/vatRepercuted/updateVatRepercuted',
        updateOrderLines: '',
        printTags: ''
    }
    const { completeData, setCompleteData, getCompleteData, tableConfiguration, setTableConfiguration } = useVatLayoutScreenLogic({ inputTableURLs, userPermissions })
    return <VatRepercutedFinishedStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration }} />
}

export default SingleVatRepercuted